import type { IDocumentRequest, IGetDocumentRequestsParams, IUpdateDocumentRequestParams } from '@condo/domain';
import { getClient } from './api-client';

export const fetchDocumentRequests = async (params?: IGetDocumentRequestsParams): Promise<{ count: number; documentRequests: IDocumentRequest[] }> => {
    return getClient('basecamp')
        .get('/document-requests', { params })
        .then(response => response.data);
};

export const updateDocumentRequest = async (documentRequestId: number, data: IUpdateDocumentRequestParams): Promise<IDocumentRequest> => {
    return getClient('salesPortal')
        .put(`/document-requests/${documentRequestId}`, data)
        .then(response => response.data);
};
